import config from "../config/config";
import noAvatar from "../assets/img/dummy/noavatar40.png";

export function imageProxy(src) {
  if (src?.indexOf('/api/image/proxy') === -1) {
    return `${config.api_base_path}/api/image/proxy?image=${encodeURIComponent(src)}`;
  }
  return src;
}